import React, { FunctionComponent } from "react";
import {checkIsUrlIncludeShop, inetDownload, isUrlShop} from "../../utils/utils";
import './ShowAllResults.scss';

export const ShowAllResults: FunctionComponent<any> = (props) => {
  const isShop =  checkIsUrlIncludeShop();
  let isKeyWordDownload = props.href ? inetDownload.some(item => props.href.toLowerCase().indexOf(item) > -1 )
      : inetDownload.some(item => props.value.toLowerCase().indexOf(item) > -1 );
  const activePillar = isShop ? isUrlShop.SHOP : (
      isKeyWordDownload ? isUrlShop.SHOP : isUrlShop.NOT_SHOP
  );
  let searchPageUrl: any = props.href ? props.href : (props.searchPageUrl + "?q=" + encodeURIComponent(props.value) + "&r=" + activePillar);
  (document.querySelector("body") as any).onclick = (e: any) => {
    // Set field to localStorage to ensure the result page is redirected from Support Search Hero
    const element = e.target as any;
    if (element.closest(".product-name-suggestion")) {
      // Create a variable to contain the configured search result page
      const searchPageUrl = document.getElementById("hiddenSearchPageUrlDiv")?.getAttribute("searchPageUrl");
      const eleId = element.getAttribute('id') ? element.getAttribute('id') : element.parentNode.getAttribute('id');
      const searchResultUrl: any = searchPageUrl + "?q=" + eleId + "&r=" + isUrlShop.NOT_SHOP;
      localStorage.setItem('pageUrl' , searchResultUrl);
      window.location = searchResultUrl;
      return;
    }
    if (element.closest("#showAllResults")) {
      localStorage.setItem('pageUrl' , searchPageUrl)
      window.location = props.isAffiliate ? props.href : encodeURI(searchPageUrl);
    }
  }

  return (
    <div className="show-all-results-cta-container" id="showAllResults">
      <div className="contained-btn-wrapper">
        <a role="button" className="btn btn-common contained-btn" href={props.isAffiliate ? encodeURI(props.href) : searchPageUrl}>
          <div className="show-all-results-btn-title">
            Show All Results
          </div>
        </a>
      </div>
    </div>
  );
}

export default ShowAllResults;
